import { Injectable, inject } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { SharedLogService } from '../log/log.service';

@Injectable({
  providedIn: 'root',
})
export class SharedErrorService {
  private sharedLogService = inject(SharedLogService);

  /**
   * Handle Http operation that failed.
   *
   * Contract (#1747):
   *  - When a `result` fallback is provided, the failure is logged and the
   *    fallback is EMITTED instead of re-thrown — graceful degradation for
   *    call sites that can render an empty list/safe default (e.g. the
   *    customer my-bookings search, #1768).
   *  - When no fallback is provided, the error is logged and RE-THROWN so
   *    stores/components with explicit error branches (error banners, retry
   *    affordances — #1252/#1287/#1740) keep receiving it.
   *
   * Callers whose consumers rely on the error propagating must NOT pass a
   * fallback (see `BaseHttpCrudService`'s `fallback` option).
   *
   * @param operation - name of the operation that failed
   * @param result - optional value to emit as the observable result
   */
  public handleError<T>(operation = 'operation', result?: T) {
    return (error: unknown): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      const message = error instanceof Error ? error.message : (error as { message?: string })?.message;
      this.sharedLogService.log(`${operation} failed: ${message}`);

      if (result !== undefined) {
        // Graceful degradation: honor the documented fallback contract.
        return of(result);
      }

      // Let the error bubble up
      return throwError(() => error);
    };
  }
}
